import { createForm } from '../../../factories'

export default createForm(['memberIDs'])



// WEBPACK FOOTER //
// ./src/store/modules/modules/forms/relateMembers.js